export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative h-[600px] w-full">
            <img
              src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/58301b1a720e2eb4f86ed0fbde0cf541.jpeg"
              alt="Luxury Watch Collection"
              className="w-full h-full object-cover object-top rounded-lg shadow-2xl"
            />
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-amber-600/10 rounded-lg -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-amber-50 text-amber-600 text-sm font-medium rounded-full mb-6">
              私たちについて
            </div>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 leading-tight">
              時を超える美しさと<br />精密な技術
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              ChronoCharmは、世界最高峰の高級腕時計を厳選してご紹介する専門サイトです。ロレックス、カルティエ、IWC、チューダーなど、名だたるブランドの最新モデルから希少なヴィンテージピースまで、幅広くカバーしています。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              私たちは単なる情報提供にとどまらず、各モデルの歴史的背景、技術的特徴、市場価値まで徹底的に分析。あなたの腕時計選びを、確かな知識でサポートします。
            </p>

          </div>
        </div>
      </div>
    </section>
  );
}
